import * as actionTypes from "./actionTypes";
import apiClient from "../../services/apiClient";
import { getMerchantId } from "../../utils/tokenManager";
import { showErrorToast, showSuccessToast } from "../../utils/errorHandler";
import { toast } from "react-toastify";
import { FillArray, imageDeleteArr } from "./imageUpload";
import { 
  prepareProductCreationRequest, 
  prepareProductMerchantRequest,
  formatSearchResults 
} from "../../utils/productMapper";

export const addItemModalStart = () => {
  return {
    type: actionTypes.ADD_ITEM_MODAL_START,
  };
};

export const addItemStart = () => {
  return {
    type: actionTypes.ADD_ITEM_START,
  };
};

export const addItemSuccess = (data) => {
  return {
    type: actionTypes.ADD_ITEM_SUCCESS,
    data,
  };
};

export const addItemFail = () => {
  return {
    type: actionTypes.ADD_ITEM_FAIL,
  };
};

export const deleteItemStart = () => {
  return {
    type: actionTypes.DELETE_ITEM_START,
  };
};

export const deleteItemSuccess = () => {
  return {
    type: actionTypes.DELETE_ITEM_SUCCESS,
  };
};

export const deleteItemFail = () => {
  return {
    type: actionTypes.DELETE_ITEM_FAIL,
  };
};

export const addItemSearchStart = () => {
  return {
    type: actionTypes.ADD_ITEM_SEARCH_START,
  };
};

export const addItemSearchSuccess = (data) => {
  return {
    type: actionTypes.ADD_ITEM_SEARCH_SUCCESS,
    data,
  };
};

export const addItemSearchFail = () => {
  return {
    type: actionTypes.ADD_ITEM_SEARCH_FAIL,
  };
};

// Measurement units action removed - unit is now a simple string field

export const clearSearchResults = () => {
  return {
    type: actionTypes.ADD_ITEM_SEARCH_CLEAR,
  };
};

export const brandsSave = (data) => {
  return {
    type: actionTypes.ADD_ITEM_BRAND,
    data,
  };
};

export const categoriesSave = (data) => {
  return {
    type: actionTypes.ADD_ITEM_CATEGORIES,
    data,
  };
};

export const addItemError = (err) => {
  return {
    type: actionTypes.ADD_ITEM_ERROR,
    err,
  };
};

export const getItemStart = () => {
  return {
    type: actionTypes.GET_ITEM_START,
  };
};

export const getItemSuccess = (itemDetails) => {
  return {
    type: actionTypes.GET_ITEM_SUCCESS,
    itemDetails,
  };
};

export const getItemFail = () => {
  return {
    type: actionTypes.GET_ITEM_FAIL,
  };
};

export const addItemStartModal = () => {
  return (dispatch) => {
    dispatch(addItemModalStart());
  };
};

export const setNewObjectData = (name, value) => {
  return {
    type: actionTypes.ITEM_DETAILS_UPDATE,
    name,
    value,
  };
};

export const updateItemDetails = (name, value) => {
  return (dispatch) => {
    dispatch(setNewObjectData(name, value));
  };
};

export const setAddNewItem = (name, value) => {
  return {
    type: actionTypes.ADD_ITEM_UPDATE_NEW_ITEM,
    name,
    value,
  };
};

export const updateAddNewItem = (name, value) => {
  return (dispatch) => {
    dispatch(setAddNewItem(name, value));
  };
};

export const deleteNewItem = () => {
  return {
    type: actionTypes.ADD_ITEM_DELETE_NEW_ITEM,
  };
};

export const deleteAddNewItemInputs = () => {
  return (dispatch) => {
    dispatch(deleteNewItem());
  };
};

export const addBatchItemStart = () => {
  return {
    type: actionTypes.ADD_BATCH_ITEM_START,
  };
};

export const addBatchItemSuccess = (data) => {
  return {
    type: actionTypes.ADD_BATCH_ITEM_SUCCESS,
    data,
  };
};

export const addBatchItemFail = () => {
  return {
    type: actionTypes.ADD_BATCH_ITEM_FAIL,
  };
};

export const setFullItemData = (name, value) => {
  return {
    type: actionTypes.ITEM_FULL_DETAILS_UPDATE,
    name,
    value,
  };
};

export const updateFullItem = (name, value) => {
  return (dispatch) => {
    dispatch(setFullItemData(name, value));
  };
};

export const updatePriceAndDiscountStart = () => {
  return {
    type: actionTypes.UPDATE_PRICE_DISCOUNT_START,
  };
};

export const updatePriceAndDiscountSuccess = (data) => {
  return {
    type: actionTypes.UPDATE_PRICE_DISCOUNT_SUCCESS,
    data,
  };
};

export const updatePriceAndDiscountFail = () => {
  return {
    type: actionTypes.UPDATE_PRICE_DISCOUNT_FAIL,
  };
};

export const putItemStart = () => {
  return {
    type: actionTypes.PUT_ITEM_START,
  };
};

export const getBrands = () => {
  return async (dispatch) => {
    try {
      const response = await apiClient.get('/brands?limit=100');
      
      // Backend wraps response in {success, data, message}
      const brandsData = response.data.data;
      dispatch(brandsSave(brandsData));
    } catch (error) {
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to fetch brands';
      showErrorToast({ message: errorMessage });
      dispatch(addItemError(error));
    }
  };
};

export const getCategories = () => {
  return async (dispatch) => {
    try {
      const response = await apiClient.get('/categories');
      
      // Backend wraps response in {success, data, message}
      const categoriesData = response.data.data;
      dispatch(categoriesSave(categoriesData));
    } catch (error) {
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to fetch categories';
      showErrorToast({ message: errorMessage });
      dispatch(addItemError(error));
    }
  };
};

export const SearchItem = (term) => {
  return async (dispatch) => {
    dispatch(addItemSearchStart());

    try {
      // Backend expects 'query' parameter, not 'term', and 'page' instead of 'offset'
      const response = await apiClient.get(`/products/search?query=${encodeURIComponent(term)}&page=1&limit=20`);
      
      // Backend wraps response in {success, data, message}
      const searchResults = response.data.data;
      
      // Format search results for frontend compatibility
      const formattedResults = formatSearchResults(searchResults);
      dispatch(addItemSearchSuccess(formattedResults));
    } catch (error) {
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to search products';
      showErrorToast({ message: errorMessage });
      dispatch(addItemSearchFail());
    }
  };
};

export const AddItemPost = (supplierID, productObj, cb) => {
  return async (dispatch) => {
    dispatch(addItemStart());

    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(addItemFail());
        return;
      }

      // Prepare product-merchant request using mapper utility
      const productId = productObj.productId || productObj.id;
      const requestData = prepareProductMerchantRequest(productId, merchantId, productObj);

      // Create product-merchant relationship
      const response = await apiClient.post(
        `/products/${productId}/merchants`,
        requestData
      );
      
      // Backend wraps response in {success, data, message}
      const result = response.data.data;
      showSuccessToast({ message: 'Product added successfully' });
      dispatch(addItemSuccess(result));
      dispatch(deleteNewItem());
      dispatch(imageDeleteArr());
      
      if (cb) {
        cb();
      }
    } catch (error) {
      dispatch(addItemFail());

      if (error.response?.status === 409) {
        toast.error('Product already exists in your inventory!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else {
        const errorMessage = error.response?.data?.error || 
                            error.response?.data?.message || 
                            'Failed to add product';
        toast.error(errorMessage, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    }
  };
};

export const AddNewItem = (supplierID, productObj, imageFiles = []) => {
  return async (dispatch) => {
    dispatch(addItemStart());
    
    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(addItemFail());
        return;
      }

      // Create new product (backend automatically creates ProductMerchant relationship)
      const productRequest = prepareProductCreationRequest(productObj, merchantId);
      
      const productResponse = await apiClient.post('/products', productRequest);
      
      // Backend wraps response in {success, data, message}
      const newProduct = productResponse.data.data;
      
      // Extract product ID — backend may return 'id' or 'productId'
      const productId = newProduct.id || newProduct.productId;

      // Upload images if provided
      if (imageFiles && imageFiles.length > 0) {
        try {
          const { uploadMultipleImages } = await import('../../services/imageUpload.service');
          
          const uploadResults = await uploadMultipleImages(imageFiles, productId);
          
          const successfulUploads = uploadResults.filter(r => r.success);
          const failedUploads = uploadResults.filter(r => !r.success);
          
          if (failedUploads.length > 0) {
            toast.warning(`Product created but ${failedUploads.length} image(s) failed to upload`, {
              position: toast.POSITION.BOTTOM_CENTER,
            });
          } else if (successfulUploads.length > 0) {
            showSuccessToast({ message: `Product created with ${successfulUploads.length} image(s)` });
          }
        } catch (imageError) {
          console.error('Error uploading images:', imageError);
          toast.warning('Product created but images failed to upload', {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } else {
        showSuccessToast({ message: 'Product created and added successfully' });
      }
      
      dispatch(addItemSuccess(newProduct));
      dispatch(deleteNewItem());
      dispatch(imageDeleteArr());
      
      return newProduct;
    } catch (error) {
      console.error('Error creating product:', error);
      dispatch(addItemFail());
      
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to create new product';
      toast.error(errorMessage, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      
      throw error;
    }
  };
};

export const ActivateProduct = (supplierID, productObj) => {
  return async (dispatch) => {
    try {
      const response = await apiClient.put(`/products/${productObj.id}`, {
        isActive: true
      });
      showSuccessToast({ message: 'Product activated successfully' });
    } catch (error) {
      console.error('Error activating product:', error);
      showErrorToast({ message: 'Failed to activate product' });
    }
  };
};

export const GetItemDetails = (productId, supplierId) => {
  return async (dispatch) => {
    dispatch(getItemStart());

    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(getItemFail());
        return;
      }

      // Get product-merchant details
      const response = await apiClient.get(
        `/products/merchants/${merchantId}/products/${productId}`
      );
      
      // Backend wraps response in {success, data, message}
      const itemDetails = response.data.data;
      dispatch(FillArray(itemDetails.imageUrls || itemDetails.images || []));
      dispatch(getItemSuccess(itemDetails));
    } catch (error) {
      console.error('Error fetching item details:', error);
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to fetch item details';
      showErrorToast({ message: errorMessage });
      dispatch(getItemFail());
    }
  };
};

export const PutItemDetails = (itemObj, supplierID, cb) => {
  return async (dispatch) => {
    dispatch(putItemStart());

    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(addItemFail());
        return;
      }

      // Get the product-merchant relationship ID
      const productMerchantId = itemObj.productMerchantId || itemObj.id;
      
      // Update product-merchant relationship
      const response = await apiClient.put(
        `/products/product-merchants/${productMerchantId}`,
        {
          price: itemObj.price || itemObj.Price,
          discount: itemObj.discount || 0,
          isAvailable: itemObj.isActive !== undefined ? itemObj.isActive : true,
          minQuantity: itemObj.minQuantity || 1,
          maxQuantity: itemObj.maxQuantity || 999,
          notes: itemObj.notes || itemObj.Description || null
        }
      );
      
      // Backend wraps response in {success, data, message}
      const result = response.data.data;
      showSuccessToast({ message: 'Product details updated successfully' });
      
      // Refresh item details
      dispatch(GetItemDetails(itemObj.product?.productId || itemObj.productId, supplierID));

      if (cb) {
        cb();
      }
    } catch (error) {
      if (error.response?.data?.error?.includes('barcode') || 
          error.response?.data?.message?.includes('barcode')) {
        toast.error('Barcode already exists!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else {
        toast.error('An error has occurred!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
      dispatch(addItemFail());
    }
  };
};

export const PutItem = (itemObj, supplierID, cb) => {
  return async (dispatch) => {
    dispatch(putItemStart());

    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(addItemFail());
        return;
      }

      // Get the product-merchant relationship ID
      const productMerchantId = itemObj.productMerchantId || itemObj.id;
      
      // Update product-merchant relationship
      const response = await apiClient.put(
        `/products/product-merchants/${productMerchantId}`,
        {
          price: itemObj.price || itemObj.Price,
          discount: itemObj.discount || 0,
          isAvailable: itemObj.isActive !== undefined ? itemObj.isActive : true,
          minQuantity: itemObj.minQuantity || 1,
          maxQuantity: itemObj.maxQuantity || 999
        }
      );
      
      // Backend wraps response in {success, data, message}
      const result = response.data.data;
      showSuccessToast({ message: 'Product updated successfully' });
      
      // Refresh item details
      dispatch(GetItemDetails(itemObj.productId, supplierID));

      if (cb) {
        cb();
      }
    } catch (error) {
      console.error('Error updating product:', error);
      showErrorToast({ message: 'Failed to update product' });
      dispatch(addItemFail());
    }
  };
};

export const DeleteItem = (itemID, supplierID) => {
  return async (dispatch) => {
    dispatch(deleteItemStart());

    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(deleteItemFail());
        return;
      }

      // Delete product-merchant relationship (not the product itself)
      await apiClient.delete(`/products/product-merchants/${itemID}`);
      showSuccessToast({ message: 'Product removed from inventory' });
      dispatch(deleteItemSuccess());
    } catch (error) {
      console.error('Error deleting product:', error);
      showErrorToast({ message: 'Failed to delete product' });
      dispatch(deleteItemFail());
    }
  };
};

export const AddBatchItem = (supplierID, recObj) => {
  return async (dispatch) => {
    dispatch(addBatchItemStart());

    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(addBatchItemFail());
        return;
      }

      // Create product-merchant relationship for batch
      const response = await apiClient.post(
        `/products/${recObj.sku || recObj.productId}/merchants`,
        {
          merchantId: merchantId,
          price: recObj.price || recObj.Price,
          discount: recObj.discount || 0,
          isAvailable: true,
          minQuantity: recObj.minQuantity || 1,
          maxQuantity: recObj.maxQuantity || 999
        }
      );
      
      // Backend wraps response in {success, data, message}
      const result = response.data.data;
      showSuccessToast({ message: 'Batch item added successfully' });
      dispatch(addBatchItemSuccess(result));
      
      // Refresh item details
      dispatch(GetItemDetails(recObj.sku || recObj.productId, supplierID));
    } catch (error) {
      console.error('Error adding batch item:', error);
      showErrorToast({ message: 'Failed to add batch item' });
      dispatch(addBatchItemFail());
    }
  };
};

export const UpdatePriceAndDiscount = (supplierID, recObj) => {
  return async (dispatch) => {
    dispatch(updatePriceAndDiscountStart());

    try {
      const merchantId = getMerchantId();
      
      if (!merchantId) {
        showErrorToast({ message: "Merchant ID not found. Please log in again." });
        dispatch(updatePriceAndDiscountFail());
        return;
      }

      // Update product-merchant price and discount
      const productMerchantId = recObj.productMerchantId || recObj.id;
      
      const response = await apiClient.put(
        `/products/product-merchants/${productMerchantId}`,
        {
          price: recObj.price || recObj.Price,
          discount: recObj.discount || 0
        }
      );
      
      // Backend wraps response in {success, data, message}
      const result = response.data.data;
      showSuccessToast({ message: 'Price and discount updated successfully' });
      dispatch(updatePriceAndDiscountSuccess(result));
      
      // Refresh item details
      dispatch(GetItemDetails(recObj.productId, supplierID));
    } catch (error) {
      console.error('Error updating price and discount:', error);
      showErrorToast({ message: 'Failed to update price and discount' });
      dispatch(updatePriceAndDiscountFail());
    }
  };
};

// ============================================================================
// NEW PRODUCTMERCHANT ACTIONS (Aligned with new backend)
// ============================================================================

export const getProductMerchantDetailsStart = () => {
  return {
    type: actionTypes.GET_PRODUCT_MERCHANT_DETAILS_START,
  };
};

export const getProductMerchantDetailsSuccess = (data) => {
  return {
    type: actionTypes.GET_PRODUCT_MERCHANT_DETAILS_SUCCESS,
    data,
  };
};

export const getProductMerchantDetailsFail = () => {
  return {
    type: actionTypes.GET_PRODUCT_MERCHANT_DETAILS_FAIL,
  };
};

export const updateProductMerchantStart = () => {
  return {
    type: actionTypes.UPDATE_PRODUCT_MERCHANT_START,
  };
};

export const updateProductMerchantSuccess = () => {
  return {
    type: actionTypes.UPDATE_PRODUCT_MERCHANT_SUCCESS,
  };
};

export const updateProductMerchantFail = () => {
  return {
    type: actionTypes.UPDATE_PRODUCT_MERCHANT_FAIL,
  };
};

/**
 * Get ProductMerchant details by ID
 * Fetches the product-merchant relationship including product details
 */
export const getProductMerchantDetails = (productMerchantId) => {
  return async (dispatch) => {
    dispatch(getProductMerchantDetailsStart());

    try {
      const response = await apiClient.get(
        `/products/product-merchants/${productMerchantId}`
      );
      
      // Backend wraps response in {success, data, message}
      const productMerchantData = response.data.data;
      
      // Fill image array if images exist
      const images = productMerchantData.product?.images || [];
      dispatch(FillArray(images));
      
      dispatch(getProductMerchantDetailsSuccess(productMerchantData));
      
      return productMerchantData;
    } catch (error) {
      console.error('Error fetching ProductMerchant details:', error);
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to fetch product details';
      showErrorToast({ message: errorMessage });
      dispatch(getProductMerchantDetailsFail());
      throw error;
    }
  };
};

/**
 * Update ProductMerchant (price, discount, stock, etc.)
 * Updates the product-merchant relationship data
 */
export const updateProductMerchant = (productMerchantId, updateData) => {
  return async (dispatch) => {
    dispatch(updateProductMerchantStart());

    try {
      const payload = {
        price: updateData.price ? parseFloat(updateData.price) : undefined,
        discountPercent: updateData.discountPercent !== undefined ? parseFloat(updateData.discountPercent) : undefined,
        stockQuantity: updateData.stockQuantity !== undefined ? parseInt(updateData.stockQuantity) : undefined,
        minOrderQty: updateData.minOrderQty !== undefined ? parseInt(updateData.minOrderQty) : undefined,
        isAvailable: updateData.isAvailable !== undefined ? updateData.isAvailable : undefined,
      };

      // Remove undefined values
      Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

      const response = await apiClient.put(
        `/products/product-merchants/${productMerchantId}`,
        payload
      );
      
      // Backend wraps response in {success, data, message}
      const result = response.data.data;
      showSuccessToast({ message: 'Product updated successfully' });
      dispatch(updateProductMerchantSuccess());
      
      // Refresh the details
      dispatch(getProductMerchantDetails(productMerchantId));
      
      return result;
    } catch (error) {
      console.error('Error updating ProductMerchant:', error);
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to update product';
      showErrorToast({ message: errorMessage });
      dispatch(updateProductMerchantFail());
      throw error;
    }
  };
};

/**
 * Update Product (name, description, category, images, etc.)
 * Updates the core product information
 */
export const updateProduct = (productId, updateData) => {
  return async (dispatch) => {
    try {
      const payload = {
        name: updateData.name,
        description: updateData.description || null,
        categoryId: updateData.categoryId ? parseInt(updateData.categoryId) : undefined,
        brandId: updateData.brandId || null,
        unit: updateData.unit || 'pcs',
        barcode: updateData.barcode || null,
        originCountry: updateData.originCountry || null,
        images: updateData.images || null,
      };

      // Remove undefined values
      Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

      const response = await apiClient.put(
        `/products/${productId}`,
        payload
      );
      
      // Backend wraps response in {success, data, message}
      const result = response.data.data;
      return result;
    } catch (error) {
      console.error('Error updating Product:', error);
      const errorMessage = error.response?.data?.error || 
                          error.response?.data?.message || 
                          'Failed to update product details';
      showErrorToast({ message: errorMessage });
      throw error;
    }
  };
};
